const release = [
  {
    path: '/patentManage',
    name: 'patentManage',
    component: () => import(/* webpackChunkName: "release" */ '@/views/release/patentManage'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '专利交易发布管理'
    }
  },
  {
    path: '/patentRelease',
    name: 'patentRelease',
    component: () => import(/* webpackChunkName: "release" */ '@/views/release/patentRelease'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '专利发布管理'
    }
  },
  {
    path: '/releaseRecord',
    name: 'releaseRecord',
    component: () => import(/* webpackChunkName: "release" */ '@/views/release/releaseRecord'),
    meta: {
      name: '知产交易 · 全网专利交易查询',
      breadCrumbName: '发布记录'
    }
  },
  
];

export default release
